import type { CustomerInvoiceListItem, CustomerInvoiceListQuery, Page, PaymentPromiseInput, PaymentPromiseListQuery, PaymentPromiseView } from '@chukua/common';
import { toListParams } from '../../../../shared/policies/list-params';
import { api } from '../../../../shared/shared.api';

export type { CustomerInvoiceListItem, PaymentPromiseView };

export function listPaymentPromises(customerId: string, query: PaymentPromiseListQuery): Promise<Page<PaymentPromiseView>> {
  return api<Page<PaymentPromiseView>>(`/customers/${customerId}/payment-promises?${toListParams(query)}`);
}

export function recordPaymentPromise(customerId: string, input: PaymentPromiseInput): Promise<PaymentPromiseView> {
  return api<PaymentPromiseView>(`/customers/${customerId}/payment-promises`, { method: 'POST', body: JSON.stringify(input) });
}

export function supersedePaymentPromise(customerId: string, promiseId: string, input: PaymentPromiseInput): Promise<PaymentPromiseView> {
  return api<PaymentPromiseView>(`/customers/${customerId}/payment-promises/${promiseId}/supersede`, { method: 'POST', body: JSON.stringify(input) });
}

export function listCustomerInvoices(customerId: string, query: CustomerInvoiceListQuery): Promise<Page<CustomerInvoiceListItem>> {
  return api<Page<CustomerInvoiceListItem>>(`/customers/${customerId}/invoices?${toListParams(query)}`);
}
